// @flow

import WSOpenedResource from 'esm-web-pro/api/resources/methods/WSOpenedResource';
import TaskRecordResource from 'esm-web-pro/api/resources/TaskRecordResource';
import TaskEntityMemberResource from './TaskEntityMemberResource';

export default class TaskResource extends WSOpenedResource {
    basePath: string = 'project_management/tasks/';

    searchPath: string = 'project_management/search-tasks/';

    objectPath: string = 'project_management/tasks/{ident}/';

    _getSearchPath = () => this.searchPath;

    nestedResources = {
        members: TaskEntityMemberResource,
        record: TaskRecordResource,
    };

    members: TaskEntityMemberResource;

    record: TaskRecordResource;

    events(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}events/`,
            'GET',
            query,
        ).then((response) => response.data);
    }

    take(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}take/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    release(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}release/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    reject(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}reject/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    pause(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}pause/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    marking(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}marking/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    escalate(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}escalate/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    transform(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}transform/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    merge(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}merge/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    split(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}split/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    taskForAnotherOrgUnit(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}task_for_another_org_unit/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    freeTasks(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath()}get_free/`,
            'GET',
            query,
        ).then((response) => response.data);
    }

    changeOwner(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}change_owner/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    getServices(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}get_services/`,
            'GET',
            query,
        ).then((response) => response.data);
    }

    linkServices(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}link_services/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    getSerializerSchema(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}get_serializer_schema/`,
            'GET',
            query,
        ).then((response) => response.data);
    }

    getWFServices(id: string, query: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}get_wf_services/`,
            'GET',
            query,
        ).then((response) => response.data);
    }

    reserveOSSPort(id: string, query: Object): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}reserve_oss_port/`,
            'POST',
            query,
        ).then((response) => response.data);
    }

    // Override list method to use searchPath
    list(query: Object): Promise<Object> {
        return this.client._request(this._getSearchPath(), 'GET', query).then((response) => response.data);
    }
}
